import { T, useI18n } from '@tribeplatform/react-components/i18n'

import { CustomHomepageSettingsFieldProps } from '../types.js'
import { CustomHomepageBaseFormField } from './CustomHomepageBaseFormField.js'

export const NewUsersHomepageFormField = ({
  formKey,
  defaultValue,
  isLoading,
  defaultHomepage,
}: CustomHomepageSettingsFieldProps) => {
  const { $t } = useI18n()

  return (
    <CustomHomepageBaseFormField
      formKey={formKey}
      defaultHomepage={defaultHomepage}
      defaultValue={defaultValue}
      isLoading={isLoading}
      label={$t({
        defaultMessage: 'Landing page for new {MEMBERS}',
        id: 'Admin.HomepageSettings.NewUsersHomepage',
      })}
      placeholder={$t({
        defaultMessage: 'Same as default homepage for returning {MEMBERS}',
        id: 'Admin.HomepageSettings.SameAsDefaultForReturning',
      })}
      helperText={<NewUsersHomepageHelperText />}
    />
  )
}

const NewUsersHomepageHelperText = () => {
  return (
    <p>
      <T
        defaultMessage="Set a specific page to welcome new {MEMBERS} after sign-up, regardless of their past activity or interactions. This is ideal for onboarding or introductory content."
        id="Admin.HomepageSettings.NewUsersHomepageHelperText"
      />
    </p>
  )
}
